import type { Size } from '../types'

export function PersonIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.6923C11.0346 11.6923 10.2099 11.3503 9.52595 10.6664C8.84198 9.98239 8.5 9.15773 8.5 8.19236C8.5 7.22698 8.84198 6.4023 9.52595 5.71833C10.2099 5.03437 11.0346 4.69238 12 4.69238C12.9653 4.69238 13.79 5.03437 14.474 5.71833C15.158 6.4023 15.5 7.22698 15.5 8.19236C15.5 9.15773 15.158 9.98239 14.474 10.6664C13.79 11.3503 12.9653 11.6923 12 11.6923ZM6.0192 19.3077C5.59742 19.3077 5.23877 19.1599 4.94327 18.8644C4.64776 18.5689 4.5 18.2103 4.5 17.7885V17.0846C4.5 16.5949 4.63302 16.1414 4.89905 15.7241C5.16507 15.3068 5.52051 14.986 5.96537 14.7616C6.95384 14.277 7.95096 13.9135 8.95672 13.6712C9.96249 13.4289 10.9769 13.3078 12 13.3078C13.023 13.3078 14.0375 13.4289 15.0432 13.6712C16.049 13.9135 17.0461 14.277 18.0346 14.7616C18.4794 14.986 18.8349 15.3068 19.1009 15.7241C19.3669 16.1414 19.5 16.5949 19.5 17.0846V17.7885C19.5 18.2103 19.3522 18.5689 19.0567 18.8644C18.7612 19.1599 18.4025 19.3077 17.9808 19.3077H6.0192Z"
        fill="currentColor"
      />
    </svg>
  )
}
